import React from 'react'
import { useNavigate } from 'react-router-dom'
function Navbar() {
    const history = useNavigate()
    
  return (
<>
<div className="Navbar_main_box">
    <div className="navbar_logo">
        {/* <img src={logoImg} alt="" /> */}
        <h3>P</h3>
        <h1>2</h1>
        <h3>P</h3>
        <h2>CALL</h2>
    </div>
    <div className="navbar_button"><button onClick={() => history('/login')}>Login Now</button></div>
</div>

</>
    )
}

export default Navbar